import { Strategy3DSOption } from "../../payment-processing/configuration-3ds/Configuration3DSSetup"

type Configuration3DSAttributes = {
    accountId: string
    strategy3DSOption: string
    minimumThresholdAmount: number
}


export type Configuration3DSDto = {
    id: string
    type: string
    attributes: Configuration3DSAttributes
}

export default class Configuration3DS {
    private dto: Configuration3DSDto
    constructor(dto: Configuration3DSDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "configuration-3ds"
    }

    getId(): string {
        return this.dto.id
    }

    getStrategy3DSOption(): Strategy3DSOption {
        const optionValue = this.dto.attributes.strategy3DSOption
        
        const valueKey = Object.keys(Strategy3DSOption).find(key => {
            return Strategy3DSOption[key] === optionValue
        })

        if (valueKey) {
            return Strategy3DSOption[valueKey]
        }
        return Strategy3DSOption.NEVER
    }

    getMinimumThresholdAmount(): number {
        return Number(this.dto.attributes.minimumThresholdAmount)
    }
}


// WEBPACK FOOTER //
// ./src/state/configuration3ds/Configuration3DS.ts